import { INSERDAWA, GETDAWA, GETDAWAID, DELETEDAWA, UPDATEDAWA } from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateDawaaAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(`/api/LawSuit`, data);
    dispatch({
      type: INSERDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: INSERDAWA,
      payload: "Error" + e,
    });
  }
};
export const GetAllDawaaAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/LawSuit?${quary}`);
    dispatch({
      type: GETDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GETDAWA,
      payload: "Error" + e,
    });
  }
};
export const GetDawaaByIdAction = (Id) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/LawSuit/GetLawSuit?id=${Id}`);
    dispatch({
      type: GETDAWAID,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GETDAWAID,
      payload: "Error" + e,
    });
  }
};
export const UpdateDawaaAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/LawSuit`, body);
    dispatch({
      type: UPDATEDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATEDAWA,
      payload: "Error" + e,
    });
  }
};

export const DeleteDawaaAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/LawSuit?id=${Id}`);
    dispatch({
      type: DELETEDAWA,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETEDAWA,
      payload: "Error" + e,
    });
  }
};
